import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";


class CloseMessage extends Component {

    render() {
        let isManualSessionActionEnabled = (this.props.config && this.props.config.configDetails && this.props.config.configDetails.allowManualSessionEnd === true);
        console.log(this.props.config.configDetails.allowManualSessionEnd ,"here checking for reset button")
        return (
            <div style={{display:"flex",flexDirection:"column"}}>
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <strong>{this.props.message.message.text}</strong>
                    <br />
                </div>
                {this.showMessageTime() && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.message.message.sentTimestamp).format("h:mm a")}</div>}
            </div>

            { this.props.config.newConversation ? <div className="s360-close-conversation-start">
                   <div  className="s360-close-conversation-start-btn" style={this.newConversationTextStyle()} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}   onClick={this.props.startNewConversation}> New Conversation </div>
            </div> : null }
          </div> 
        )
    }

  

    showMessageTime = () => {
        return (this.props.message.type !== MessageType.info);
    }

    messageTimeClassName = () => {
        switch (this.props.message.type) {
            case MessageType.info: return "s360-message-time-info";
            default: return "";
        }
    }

    messageBoxClassName = () => {
        switch (this.props.message.type) {
            case MessageType.info: return "s360-message-box-info";
            default: return "";
        }
    }

    messageContainerClassName = () => {
        switch (this.props.message.type) {
            case MessageType.info: return "s360-message-cotainer-info";
            default: return "";
        }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        switch (this.props.message.type) {
            case MessageType.info: return { paddingTop:"10px", fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageCloseTextFontColor }
            default: return {}
        }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        switch (this.props.message.type) {
            case MessageType.info:     return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            default: return {}
        }
    }

    onMouseEnter = (e) => {
        if (!e.target) { return }
        if (e.target.disabled === true) { return }
        const designDetails = this.props.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonHighlightTextColor)       ? "white" : designDetails.buttonHighlightTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonHighlightBackgroundColor) ? "rgb(3, 19, 122)" : designDetails.buttonHighlightBackgroundColor;
    }

    onMouseLeave = (e) => {
        if (!e.target) { return }
        // if (e.target.disabled === true) { return }
        const designDetails = this.props.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonTextColor)       ? "rgb(3, 19, 122)" : designDetails.buttonTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonBackgroundColor) ? "white" : designDetails.buttonBackgroundColor;
    }

    newConversationTextStyle = () => {
        const designDetails = this.props.config.designDetails;
        return {
            // color: this.props.config.designDetails.selectionButtonsvgColor,
            fontFamily: this.props.config.designDetails.selectionButtonFont,
            fontSize: this.props.config.designDetails.selectionButtonFontSize+"px",
            // background: this.props.config.designDetails.selectionButtonBkgColor

            color:           isNullOrUndefined(designDetails.buttonTextColor)       ? "rgb(3, 19, 122)" : designDetails.buttonTextColor,
            backgroundColor: isNullOrUndefined(designDetails.buttonBackgroundColor) ? "white" : designDetails.buttonBackgroundColor,
            border:'1px solid rgb(3, 19, 122)'
        }
    }

}

export default CloseMessage;
